import { render, staticRenderFns } from "./SimpleLoading.vue?vue&type=template&id=e5dff320&scoped=true&"
import script from "./SimpleLoading.vue?vue&type=script&lang=js&"
export * from "./SimpleLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dff320",
  null
  
)

export default component.exports